export const IS_LIVE = import.meta.env.VITE_ENV === 'production';

export const DEEP_LINK_PREFIXES = {
  development: '8rrW',
  hotfixes: 'BvLi',
  production: 'rB6u',
  stage: 'jFVI'
};
